define([
    "dojo/_base/declare",
    "csi/config",
    "csi/def/Action",
    "csi/resolver",
    "csi/xml"
], function(declare,config,Action,resolver,xml) {

    return declare(Action,  {
        validate: function(/*Context*/ctx) {
            var node = ctx.getNode();
            var nodeState = xml.enumGetText(node.State);
            var	allowIssues = config.getNodeSetting(resolver.resolveParent(node), "AllowIssues");
            if(allowIssues === null) { //when there is no setting allow issues defined
            	allowIssues = true;
            }
            return allowIssues && (nodeState != "Draft");
        }
    });
});